module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/47/assets/images/2f49a78771780f84ffc21cc834b3fdb1.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_lowest.svg
// module id = /ry3
// module chunks = 0